import "../../styles/common/footer.css";
import { Link } from "react-router-dom";


const Footer = () => {
    return (
        <div>
            <footer className="footer">
                <div className="footer-contents">
                    <div className="footer-color"/>

                    <div className="nav-footer">
                        <Link to="/about-us">
                            <button className="nav-item-footer">About Us</button>
                        </Link>

                        <Link to="/independent-living">
                            <button className="nav-item-footer">Independent Living</button>
                        </Link>

                        <Link to="/#contact">
                            <button className="nav-item-footer">Contact Us</button>
                        </Link>
                    </div>
                </div>

                <div className ="copyright-notice">@Comfort Care 24/7 LLC</div>
            </footer>

            {/* Mobile Footer */}
            <footer className="footer-mobile">
                <div className="footer-mobile-body">
                        <div className="footer-mobile-column">
                            <ul>
                                <li className="footer-mobile-text">
                                    <Link to="/about-us">About Us</Link>
                                </li>
                                <li className="footer-mobile-text">
                                    <Link to="/independent-living">Independent Living</Link>
                                </li>
                                <li className="footer-mobile-text">
                                    <Link to="/#contact">Contact Us</Link>
                                </li>
                            </ul>
                        </div>
                </div>

                <div className ="copyright-notice">@Comfort Care 24/7 LLC</div>

            </footer>
        </div>
    )
}

export default Footer;